import styled from "styled-components";
import Switch from "rc-switch";
import { ActionButton } from "@talentbait/shared-components";

export const customStyles = {
  control: (provided, state) => ({
    ...provided,
    background: "#fff",
    borderColor: "#9e9e9e",
    minHeight: "40px",
    height: "40px",
    boxShadow: state.isFocused ? null : null
  }),

  valueContainer: (provided, state) => ({
    ...provided,
    height: "40px",
    padding: "0 6px"
  }),

  input: (provided, state) => ({
    ...provided,
    margin: "0px"
  }),
  indicatorSeparator: (state) => ({
    display: "none"
  }),
  indicatorsContainer: (provided, state) => ({
    ...provided,
    height: "40px"
  })
};

export const customStylesCompanies = {
  container: (provided, state) => ({
    ...provided,
    width: "100%"
  }),

  control: (provided, state) => ({
    ...provided,
    background: "var(--primary-white)",
    borderColor: state.isFocused ? "var(--primary-blue)" : "var(--primary-dark-200)",
    borderRadius: "5px",
    minHeight: "50px",
    height: "50px",
    padding: "0 10px",
    boxShadow: state.isFocused ? "0 0 0 1px var(--primary-blue)" : "none"
  }),

  valueContainer: (provided, state) => ({
    ...provided,
    height: "50px",
    padding: "0 10px",
    display: "flex",
    alignItems: "center"
  }),

  input: (provided, state) => ({
    ...provided,
    margin: "0px",
    color: "var(--primary-blue)",
    fontSize: "var(--fs-base)",
    fontWeight: 400,
    lineHeight: "var(--lh-base)"
  }),

  placeholder: (provided, state) => ({
    ...provided,
    color: "var(--primary-dark-300)",
    fontSize: "var(--fs-base)",
    fontWeight: 400,
    lineHeight: "var(--lh-base)",
    margin: 0
  }),

  singleValue: (provided, state) => ({
    ...provided,
    color: "var(--primary-blue)",
    fontSize: "var(--fs-base)",
    fontWeight: 400,
    lineHeight: "var(--lh-base)"
  }),

  indicatorSeparator: (state) => ({
    display: "none"
  }),

  indicatorsContainer: (provided, state) => ({
    ...provided,
    height: "50px"
  })
};

export const ChatFormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3rem;
  min-width: 660px;
  max-width: 660px;
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  width: ${({ width }) => width || "100%"};
  min-width: ${({ minWidth }) => minWidth || "auto"};

  input:is(input[type="text"]) {
    height: 50px;
  }

  input:not(input[type="text"]) {
    height: 40px;
  }

  #search-icon {
    top: 6px;
    position: absolute;
    left: 1px;
  }
`;

export const ContentTitle = styled.span`
  color: var(--primary-dark-300);
  font-size: var(--fs-base);
  font-weight: 400;
  line-height: var(--lh-base);
  display: flex;
  align-items: center;
`;

export const ContentTitleFooter = styled(ContentTitle)`
  font-weight: 600;
  text-transform: uppercase;
`;

export const TextInput = styled.input`
  width: 100%;
  height: 50px;
  border-radius: 5px;
  border: 1px solid var(--primary-dark-200);
  background: var(--primary-white);
  padding: 10px 20px;

  overflow: hidden;
  color: var(--primary-blue);
  font-size: var(--fs-base);
  font-weight: 400;
  line-height: var(--lh-base);

  &::placeholder {
    color: var(--primary-dark-300);
  }

  &:focus {
    border-color: var(--primary-blue);
    box-shadow: 0 0 0 1px var(--primary-blue);
    outline: none;
  }

  &:-webkit-autofill,
  &:-webkit-autofill:hover,
  &:-webkit-autofill:focus,
  &:-webkit-autofill:active {
    -webkit-box-shadow: 0 0 0 30px var(--primary-white) inset !important;
    -webkit-text-fill-color: var(--primary-blue) !important;
  }
`;

export const NextButton = styled(ActionButton)`
  width: 30%;
`;

export const RemoteJobSwitch = styled(Switch)`
  width: 60px;
  height: 30px;
  background-color: ${({ $isCheck }) => ($isCheck ? "var(--primary-green)" : "var(--primary-red)")};
  border-color: ${({ $isCheck }) => ($isCheck ? "var(--primary-green)" : "var(--primary-red)")};

  .rc-switch-inner {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
  }

  .rc-switch-checked:after {
    left: 50%;
    transform: translateX(-50%);
  }

  .rc-switch:after {
    right: 50%;
    transform: translateX(50%);
  }
`;

export const RemoteJobCheckbox = styled.input`
  width: 20px;
  height: 20px;
  margin-right: 10px;
  accent-color: var(--primary-blue);
`;

export const RemoteJobLabel = styled.label`
  color: var(--primary-dark-600);
  font-size: var(--fs-base);
  font-weight: 600;
  line-height: var(--lh-base);
`;
